<template>
  <div class="apply-page">
    <img src="../assets/apply/apply1.jpg" alt="">
    <img src="../assets/apply/apply2.jpg" alt="">
    <img src="../assets/apply/apply3.jpg" alt="">
  </div>
</template>

<script>
import icon1 from '../assets/partner/icon1.png'
import icon2 from '../assets/partner/icon2.png'
import icon3 from '../assets/partner/icon3.png'
import icon4 from '../assets/partner/icon4.png'
import icon5 from '../assets/partner/icon5.png'
import icon6 from '../assets/partner/icon6.png'
export default {
  data() {
    return {

    };
  },
  methods:{

  },
  created(){

  },
  updated(){
    
  },
};
</script>

<style lang="less" scoped>
.apply-page{
  text-align: center;
  margin-top: 70px;
}

</style>


// WEBPACK FOOTER //
// src/pages/apply.vue